module.exports = __webpack_public_path__ + "img/guide_current.ca646631.svg";